// extracted by mini-css-extract-plugin
module.exports = {"fullScreenButton":"FullScreen_fullScreenButton__3TkyF"};